module.exports = "/src/views/donate/main/elements/shop/img/p_1.svg";